import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import SubmitToApproveAPI from './SubmitToApproveAPI';

export default function SubmittoapproveActionImpl() {
    
    return (
        <>
        <SubmitToApproveAPI/>
        </>
    )
}